<template>
  <div class="homecare-topic-ventilator-area">
    <div v-for="(pageRow, pageIndex) in listPage" :key="pageIndex" class="page print-info-area fs13 p20 mb-4">
      <PDFHeader :title="$t('home_care_notebook')"/>
      <div class="bodyPDF">
        <div class="detail-content-area">
          <p v-if="pageIndex == 0" class="title-table">{{tableTitle}}</p>
          <div v-if="pageIndex == 0" class="list-time-area">
            <ul>
              <li class="pl-3 pr-3">更新日：{{dataTabFormatted.date}}</li>
            </ul>
          </div>
          <div :class="['home-care-table', tableName ]">
            <table v-if="pageIndex == 0">
              <tr>
                <td>製品名</td>
                <td colspan="3">{{dataTabFormatted.product_name_ventilator}}</td>
              </tr>
            </table>
            <div v-for="(row, rowIndex) in pageRow" class="table-image-area" :key="row.rowName+rowIndex">
              <div :class="['title-list-image', ((pageIndex > 0 && rowIndex == 0) ? '' : 'border-top-0')]">{{row.rowTitle}}</div>
              <div class="list-image" >
                <p v-if="row.rowData == null">画像のデータがありません</p>
                <template v-else>
                  <img
                    v-for="(img_url, index) in row.rowData"
                    :key="'ventilator_'+row.rowName+'_'+index"
                    :src="img_url"
                    :style="[(row.rowData.length == 1 ? {maxWidth: '100%'} : ''), { maxHeight: '690px' }]"
                  />
                </template>
              </div>
              <hr v-if="pageIndex == listPage.length - 1 && rowIndex == pageRow.length - 1" class="float-left w-100">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const HEIGHT_OF_SPACE_AREA_FIRST_PAGE = 855 // height of paper - padding top bottom - header - title - first row - end line = 1123 - 40 - 110 - 36 - 40 - 42
import PDFHeader from '../PDFHeader.vue'
import { HEIGHT_OF_SPACE_AREA, HEIGHT_DEFAULT_OF_IMAGE_AREA, HEIGHT_OF_ROW_WITHOUT_DATA, HEIGHT_OF_TITLE_ROW } from '@/js/commons/commons'
export default {
  components: {
    PDFHeader,
  },
  props: [
    'tableName',
    'tableTitle',
    'listColumnTable',
    'dataTabFormatted'
  ],
  data() {
    return {
      listPage: [],
    }
  },
  created() {
    this.splitTableToManyPage()
  },
  async mounted() {
    await Promise.all(Array.from(document.querySelectorAll('.homecare-topic-ventilator-area img')).map(img => {
      if (img.complete)
        return Promise.resolve(img.naturalHeight !== 0);
      return new Promise(resolve => {
        img.addEventListener('load', () => resolve(true));
        img.addEventListener('error', () => resolve(false));
      });
    })).then(results => {
      if (results.every(res => res)) {
        setTimeout(() => {
          this.mergePage()
        }, 10);
      }
    });
  },
  methods: {
    splitTableToManyPage() {
      let spaceArea = HEIGHT_OF_SPACE_AREA_FIRST_PAGE
      let pageIndex = 0
      this.listPage.push([])
      for (const [key, value] of Object.entries(this.listColumnTable)) {
        let heightThisRow = HEIGHT_OF_ROW_WITHOUT_DATA + HEIGHT_OF_TITLE_ROW
        if(this.dataTabFormatted[key] && this.dataTabFormatted[key].length > 0) {
          // split page when row have many image
          let chuck = 2
          for (let i = 0; i < this.dataTabFormatted[key].length; i += chuck) {
            let rowData = this.dataTabFormatted[key].slice(i, i + chuck)
            heightThisRow = HEIGHT_DEFAULT_OF_IMAGE_AREA + HEIGHT_OF_TITLE_ROW
            spaceArea -= heightThisRow
            if(spaceArea < 0) {
              this.listPage.push([])
              spaceArea = HEIGHT_OF_SPACE_AREA - heightThisRow
              pageIndex++
            }
            this.listPage[pageIndex].push({rowName: key, rowTitle: value, rowData: rowData})
          }
        }
        else {
          spaceArea -= heightThisRow
          if(spaceArea < 0) {
            this.listPage.push([])
            spaceArea = HEIGHT_OF_SPACE_AREA - heightThisRow
            pageIndex++
          }
          this.listPage[pageIndex].push({rowName: key, rowTitle: value, rowData: null})
        }
      }
    },
    mergePage() {
      let previousVentilatorPage = null
      let spaceArea = HEIGHT_OF_SPACE_AREA_FIRST_PAGE
      Array.from(document.querySelectorAll('.homecare-topic-ventilator-area .page')).forEach(ventilatorPage => {
        if(previousVentilatorPage) {
          let isPreviousVentilatorHaveImage = (previousVentilatorPage && previousVentilatorPage.getElementsByTagName('img').length > 0)
          let previousBody = previousVentilatorPage.querySelector('.bodyPDF .detail-content-area .ventilator')
          let currentBody = ventilatorPage.querySelector('.bodyPDF .detail-content-area .ventilator')
          let isPreviousRowHaveImage = false
          Array.from(ventilatorPage.getElementsByClassName('table-image-area')).forEach(tableImageEl => {
            let isTableImageHaveImage =  tableImageEl.getElementsByTagName('img').length > 0
            if(!isPreviousRowHaveImage && previousBody.offsetHeight + tableImageEl.offsetHeight < spaceArea && !(isPreviousVentilatorHaveImage && isTableImageHaveImage)) {
              tableImageEl.children[0].classList.add("border-top-0")
              previousBody.insertAdjacentElement('beforeEnd', tableImageEl)
              tableImageEl.nextElementSibling ? tableImageEl.nextElementSibling.classList.remove("border-top-0") : null
            }
            if(currentBody.children.length == 0) {
              ventilatorPage.remove()
            }
            isTableImageHaveImage ? isPreviousRowHaveImage = true : null
          })
        }
        previousVentilatorPage = ventilatorPage
        spaceArea = HEIGHT_OF_SPACE_AREA
      })
    }
  }
}
</script>
<style scoped>
  .list-image {
    max-height: 900px;
  }
</style>
